import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import classes from "../Homescreen/Homescreen.module.css";
import { onAuthStateChanged } from "firebase/auth";
import { db, auth, storage } from "../firebase-config";
import { getDownloadURL, listAll, ref, uploadBytes } from "firebase/storage";
import { collection, query, where, getDocs } from "firebase/firestore";

function Info() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);

  const [userCorpFiles, setUserCorpFiles] = useState([]);
  const [userContractFiles, setUserContractFiles] = useState([]);
  const [userOtherFiles, setUserOtherFiles] = useState([]);

  const [openMenu1, setOpenMenu1] = useState(false);
  const [openMenu2, setOpenMenu2] = useState(false);
  const [openMenu3, setOpenMenu3] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [fileUpload, setFileUpload] = useState([null]);
  const navigate = useNavigate();

  const uploadFile = () => {
    if (fileUpload == null) return;
    const fileRef = ref(
      storage,
      `clients_uploads/${fileUpload.name + "_" + userData.email}`
    );
    uploadBytes(fileRef, fileUpload).then(() => {
      alert("file uploaded, thanks!");
      navigate("/home");
    });
  };

  const handleMenu1Click = () => {
    setOpenMenu1(!openMenu1);
    setOpenMenu2(false);
    setOpenMenu3(false);
  };

  const handleMenu2Click = () => {
    setOpenMenu2(!openMenu2);
    setOpenMenu1(false);
    setOpenMenu3(false);
  };

  const handleMenu3Click = () => {
    setOpenMenu3(!openMenu3);
    setOpenMenu1(false);
    setOpenMenu2(false);
  };

  const userCorpFilesRef = ref(storage, auth.currentUser.email + "/corporate/");
  const userContractFilesRef = ref(
    storage,
    auth.currentUser.email + "/contracts/"
  );
  const userOtherFilesRef = ref(storage, auth.currentUser.email + "/other/");

  useEffect(() => {
    listAll(userCorpFilesRef).then((response) => {
      const promises = response.items.map((item) => {
        return getDownloadURL(item).then((url) => [url, item.name]);
      });
      Promise.all(promises).then((results) => {
        setUserCorpFiles(results);
        setIsLoading(false);
      });
    });
  }, []);

  useEffect(() => {
    listAll(userContractFilesRef).then((response) => {
      const promises = response.items.map((item) => {
        return getDownloadURL(item).then((url) => [url, item.name]);
      });
      Promise.all(promises).then((results) => {
        setUserContractFiles(results);
        setIsLoading(false);
      });
    });
  }, []);

  useEffect(() => {
    listAll(userOtherFilesRef).then((response) => {
      const promises = response.items.map((item) => {
        return getDownloadURL(item).then((url) => [url, item.name]);
      });
      Promise.all(promises).then((results) => {
        setUserOtherFiles(results);
        setIsLoading(false);
      });
    });
  }, []);

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
  }, []);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, retrieve their data from Firestore
        setUser(user);
        const q = query(
          collection(db, "clients"),
          where("email", "==", user.email)
        );
        getDocs(q)
          .then((querySnapshot) => {
            if (!querySnapshot.empty) {
              const doc = querySnapshot.docs[0];
              setUserData(doc.data());
            } else {
              console.log("No such document!");
            }
          })
          .catch((error) => {
            console.log("Error getting document:", error);
          });
      } else {
        // User is signed out, reset user data
        setUser(null);
        setUserData(null);
      }
    });

    return unsubscribe;
  }, []);

  return (
    <div className={classes.mainscreen_display}>
      <div>
        {user ? (
          <div>
            {userData ? (
              <div>
                <pre>
                  <div className={classes.cardBox}>
                    <div className={classes.card}>
                      <div className={classes.cardName}>
                        <h3
                          style={{
                            fontSize:
                              userData.company_name.length > 27
                                ? "18px"
                                : "1.3em",
                          }}
                        >
                          {userData.company_name}
                        </h3>
                        company name
                      </div>
                      <div className={classes.iconBx}>
                        <ion-icon name="ribbon-outline"></ion-icon>
                      </div>
                    </div>
                    <div className={classes.card}>
                      <div className={classes.cardName}>
                        <h3>{userData.director}</h3>
                        applicant
                      </div>
                      <div className={classes.iconBx}>
                        <ion-icon name="person-outline"></ion-icon>
                      </div>
                    </div>
                    <div className={classes.card}>
                      <div className={classes.cardName}>
                        <h3>{userData.person_in_charge}</h3>
                        person-in-charge
                      </div>
                      <div className={classes.iconBx}>
                        <ion-icon name="walk-outline"></ion-icon>
                      </div>
                    </div>
                    <div className={classes.card}>
                      <div className={classes.cardName}>
                        <h3>{userData.status}</h3>
                        status
                      </div>
                      <div className={classes.iconBx}>
                        <ion-icon name="star-outline"></ion-icon>
                      </div>
                    </div>
                  </div>
                  <div className={classes.cardBox_bigbox}>
                    <div className={classes.details}>
                      <div className={classes.details_info}>
                        <h2>My data:</h2>
                        <table>
                          <thead>
                            <tr>
                              <td>
                                <h3>Title</h3>
                              </td>
                              <td>
                                <h3>Data</h3>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <p>Date of registration:</p>
                              </td>
                              <td>
                                <p>{userData.registration_date}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Business organisation form:</p>
                              </td>
                              <td>
                                <p>{userData.business_organisation_form}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Company registration number:</p>
                              </td>
                              <td>
                                <p>{userData.company_registration_number}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Shareholders:</p>
                              </td>
                              <td>
                                <p>{userData.shareholders}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Principal activity:</p>
                              </td>
                              <td>
                                <p>{userData.principal_activity}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Address:</p>
                              </td>
                              <td>
                                <p>{userData.address}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Mobile:</p>
                              </td>
                              <td>
                                <p>{userData.mobile}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>E-mail:</p>
                              </td>
                              <td>
                                <p>{userData.email}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Website:</p>
                              </td>
                              <td>
                                <p>{userData.website}</p>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <p>Notes:</p>
                              </td>
                              <td>
                                <p>{userData.notes}</p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className={classes.details_docs}>
                        <h2>My Documents:</h2>

                        <table>
                          <tbody>
                            <tr
                              className={classes.docsClick}
                              onClick={handleMenu1Click}
                            >
                              {openMenu1 ? (
                                <>
                                  <td>
                                    Corporate{" "}
                                    <ion-icon name="caret-up-outline"></ion-icon>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </>
                              ) : (
                                <>
                                  <td>
                                    Corporate{" "}
                                    <ion-icon name="caret-down-outline"></ion-icon>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                            </tr>
                            {openMenu1 && (
                              <>
                                {isLoading ? (
                                  <p>Loading...</p>
                                ) : (
                                  <>
                                    {userCorpFiles.map((userCorpFile) => {
                                      return (
                                        <tr key={userCorpFile[1]}>
                                          <td>{userCorpFile[1]}</td>
                                          <td></td>
                                          <td
                                            onClick={() => {
                                              window.open(userCorpFile[0]);
                                            }}
                                          >
                                            <ion-icon name="cloud-download-outline"></ion-icon>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </>
                                )}
                              </>
                            )}

                            <tr
                              className={classes.docsClick}
                              onClick={handleMenu2Click}
                            >
                              {openMenu2 ? (
                                <>
                                  <td>
                                    Contracts{" "}
                                    <ion-icon name="caret-up-outline"></ion-icon>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </>
                              ) : (
                                <>
                                  <td>
                                    Contracts{" "}
                                    <ion-icon name="caret-down-outline"></ion-icon>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                            </tr>
                            {openMenu2 && (
                              <>
                                {isLoading ? (
                                  <p>Loading...</p>
                                ) : (
                                  <>
                                    {userContractFiles.map(
                                      (userContractFile) => {
                                        return (
                                          <tr key={userContractFile[1]}>
                                            <td>{userContractFile[1]}</td>
                                            <td></td>
                                            <td
                                              onClick={() => {
                                                window.open(
                                                  userContractFile[0]
                                                );
                                              }}
                                            >
                                              <ion-icon name="cloud-download-outline"></ion-icon>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </>
                                )}
                              </>
                            )}

                            <tr
                              className={classes.docsClick}
                              onClick={handleMenu3Click}
                            >
                              {openMenu3 ? (
                                <>
                                  <td>
                                    Other{" "}
                                    <ion-icon name="caret-up-outline"></ion-icon>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </>
                              ) : (
                                <>
                                  <td>
                                    Other{" "}
                                    <ion-icon name="caret-down-outline"></ion-icon>
                                  </td>
                                  <td></td>
                                  <td></td>
                                </>
                              )}
                            </tr>
                            {openMenu3 && (
                              <>
                                {isLoading ? (
                                  <p>Loading...</p>
                                ) : (
                                  <>
                                    {userOtherFiles.map((userOtherFile) => {
                                      return (
                                        <tr key={userOtherFile[1]}>
                                          <td>{userOtherFile[1]}</td>
                                          <td></td>
                                          <td
                                            onClick={() => {
                                              window.open(userOtherFile[0]);
                                            }}
                                          >
                                            <ion-icon name="cloud-download-outline"></ion-icon>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </>
                                )}
                              </>
                            )}
                          </tbody>
                        </table>
                        <div className={classes.details_docs_bottom}>
                          <div className={classes.listOfServices}>
                            <h2>My current services:</h2>

                            <table>
                              <tbody>
                                <tr>
                                  <td>{userData.client_services}</td>
                                </tr>
                                <tr>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <h2 style={{ margin: "5% 0 2% 0" }}>Upload:</h2>

                          <div className={classes.upload}>
                            <table>
                              <tbody>
                                <tr style={{ borderBottom: "none" }}>
                                  <td>
                                    <input
                                      type="file"
                                      onChange={(e) => {
                                        setFileUpload(e.target.files[0]);
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <ion-icon
                                      onClick={uploadFile}
                                      name="cloud-upload-outline"
                                    ></ion-icon>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </pre>
              </div>
            ) : (
              <p>Loading your data...</p>
            )}
          </div>
        ) : (
          <p>Please sign in to view your data.</p>
        )}
      </div>
    </div>
  );
}

export default Info;
